export default __webpack_public_path__ + "static/media/icon-2.c06a3ab0.png";